import type { ISerialize } from '@/objects/ISerialize';

export class SignalrDeviceStatusSubscribeParameters implements ISerialize {
    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {}) {}

    public serialize(): string {
        return '{' + '}';
    }

    /**
     * Creates an instance of SignalrDeviceStatusSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {}): SignalrDeviceStatusSubscribeParameters {
        return new SignalrDeviceStatusSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrDeviceStatusSubscribeParameters {
        return new SignalrDeviceStatusSubscribeParameters({});
    }

    /**
     * Creates an instance of SignalrDeviceStatusSubscribeParameters from another instance of SignalrDeviceStatusSubscribeParameters.
     * @param other The SignalrDeviceStatusSubscribeParameters you want to clone
     * @returns A cloned SignalrDeviceStatusSubscribeParameters
     */
    public static FromOther(other: SignalrDeviceStatusSubscribeParameters): SignalrDeviceStatusSubscribeParameters {
        return SignalrDeviceStatusSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrDeviceStatusSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrDeviceStatusSubscribeParameters';
}
